




import { Component, Vue } from 'vue-property-decorator';

import ManageLoyaltyV1 from './v1/ManageLoyalty.vue';
import ManageLoyaltyV2 from './v2/ManageLoyalty.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    ManageLoyaltyV1,
    ManageLoyaltyV2
  }
})
export default class CoinImage extends Vue {
  get newManageLoyaltyIsActive() {
    const flags = this.$store.getters['flags/getFlags'];

    return flags.includes(flagKeys.newManageLoyaltyPage);
  }

  get manageLoyaltyComponent() {
    return {
      0: 'ManageLoyaltyV1',
      1: 'ManageLoyaltyV2'
    };
  }
}
